import { render, staticRenderFns } from "./WidgetsSalePaymentBucket.vue?vue&type=template&id=7dd99828"
import script from "./WidgetsSalePaymentBucket.vue?vue&type=script&lang=js"
export * from "./WidgetsSalePaymentBucket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports